import moment from 'moment-timezone';
import swal from 'sweetalert2';
import { mapState, mapGetters } from 'vuex';
import get from 'lodash/get';
import find from 'lodash/find';
import map from 'lodash/map';
import eventHub from 'viralstyle-ui/src/eventHub';

import config from 'config';
import { designer, teamMember, admin, root } from 'utils/sub-user-privileges';
import { privileges } from 'domains/base/_base-enum';

export default {
  computed: {
    ...mapState({
      currentUser: state => state.currentUser,
      currentUserRole: state => state.currentUserRoleInfo.role,
      currentCampaign: state => state.campaigns.currentCampaign,
      domains: state => state.whitelabel.domains,
      campaigns: state => state.campaigns.campaigns.all.campaigns,
    }),
    ...mapGetters(['permissionViewPayouts', 'permissionRequestPayouts']),
    campaignEnded() {
      let status = get(this.currentCampaign, 'info.status'),
        endedStatuses = ['ENDED', 'FAILED'];

      return endedStatuses.includes(status);
    },
    clientAdminUrl() {
      return `${config.APP_PROTOCOL}://${config.APP_URL}`;
    },
    storeUrl() {
      return `${this.clientAdminUrl}/store/${this.currentUser.public_name}/`;
    },
    createLink() {
      return `${config.APP_PROTOCOL}://${config.APP_URL}/designer`;
    },
    hasWhitelabelDomain() {
      return get(this.currentUser, '_links.get_whitelabel_domains.href');
    },
    profileUrl() {
      return `${config.APP_PROTOCOL}://${config.APP_URL}/my-account/order-history`;
    },
    canRequestPayout() {
      return this.currentUser.valid_w9 && !this.currentUser._links.send_email_verification.href;
    },
    hasVSCampaigns() {
      return !this.hasWhitelabelDomain || find(this.campaigns, campaign => !map(this.domains, 'domain').includes(campaign.domain));
    },
  },
  methods: {
    hasPrivilege(privilege, role) {
      role = role || this.currentUserRole;

      if (privilege === privileges.SETTINGS && (this.permissionViewPayouts || this.permissionRequestPayouts)) {
        return true;
      }

      switch (role) {
        case 'CLIENT':
          return root.includes(privilege);
          break;
        case 'CLIENT-PRO':
          return root.includes(privilege);
          break;
        case 'CLIENT-SUB-ADMIN':
          return admin.includes(privilege);
          break;
        case 'CLIENT-SUB-TEAM-MEMBER':
          return teamMember.includes(privilege);
          break;
        case 'CLIENT-SUB-DESIGNER':
          return designer.includes(privilege);
          break;
      }
    },
    date(value, timezone, format) {
      if (timezone) {
        return moment.utc(value).tz(timezone).format(format ? format : 'M/D/YY h:mm A');
      } else {
        return moment.utc(value).tz(this.currentUser.timezone).format(format ? format : 'M/D/YY h:mm A');
      }
    },
    datesFromSelection(selection, timezone) {
      let start, end;

      timezone = timezone || this.currentUser.timezone;

      switch (selection) {
        case 'Today':
          start = moment().tz(timezone).startOf('day');
          end = moment().tz(timezone).endOf('day');
          break;
        case 'Yesterday':
          start = moment().tz(timezone).subtract(1, 'days').startOf('day');
          end = moment().tz(timezone).subtract(1, 'days').endOf('day');
          break;
        case 'Last 7 Days':
          start = moment().tz(timezone).subtract(6, 'days').startOf('day');
          end = moment().tz(timezone).endOf('day');
          break;
        case 'Last 14 Days':
          start = moment().tz(this.currentUser.timezone).subtract(13, 'days').startOf('day');
          end = moment().tz(this.currentUser.timezone).endOf('day');
          break;
        case 'Last 30 Days':
          start = moment().tz(timezone).subtract(29, 'days').startOf('day');
          end = moment().tz(timezone).endOf('day');
          break;
        case 'All Time':
          start = 'all';
          end = 'all';
          break;
      }

      return { start, end };
    },
    confirmPopup(title = 'Are you sure you want to leave?', text = 'You have unsaved changes.') {
      return new Promise(async (resolve, reject) => {
        const { value } = await swal({
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: config.ERROR_COLOR,
          title,
          text,
          confirmButtonText: 'Yes',
        });

        if (value) {
          resolve();
        } else {
          reject();
        }
      });
    },
    goToNext(e, next) {
      if (next) next();
      else eventHub.$emit('confirm-redirect', e);
    },
    async handleUnload(next, preventUnload, value, property = 'currentUser', item, customFunc) {
      if (!item) item = this.$store.state;

      if (preventUnload) {
        eventHub.$emit('prevent-redirect');

        try {
          await this.confirmPopup();

          this.$store.commit('updateStateClone', { object: item, property, value });

          next();
        } catch (e) {}
      } else {
        next();
      }
    },
    async handleRedirect(type, preventRedirect) {
      if (preventRedirect) {
        eventHub.$emit('prevent-redirect');

        try {
          await this.confirmPopup();

          eventHub.$emit('confirm-redirect', type);
        } catch (e) {}
      } else {
        eventHub.$emit('confirm-redirect', type);
      }
    },
  },
};